import { useMutationHandler } from "@sinch/hooks/useMutationHandler";
import {
  CopyRatelist,
  CreateRate,
  DeleteRatelist,
  EditRate,
  LinkRatelistToCompany,
  RemoveDefaultRatelistForCompany,
  SetDefaultRatelist,
  SetDefaultRatelistForCompany,
  SetRatelistStatus,
  UnlinkRatelistFromCompany,
} from "./queries.graphql";
import type {
  CopyRatelistMutation,
  CopyRatelistMutationVariables,
  CreateRateMutation,
  CreateRateMutationVariables,
  DeleteRatelistMutation,
  DeleteRatelistMutationVariables,
  EditRateMutation,
  EditRateMutationVariables,
  LinkRatelistToCompanyMutation,
  LinkRatelistToCompanyMutationVariables,
  RemoveDefaultRatelistForCompanyMutation,
  RemoveDefaultRatelistForCompanyMutationVariables,
  SetDefaultRatelistForCompanyMutation,
  SetDefaultRatelistForCompanyMutationVariables,
  SetDefaultRatelistMutation,
  SetDefaultRatelistMutationVariables,
  SetRatelistStatusMutation,
  SetRatelistStatusMutationVariables,
  UnlinkRatelistFromCompanyMutation,
  UnlinkRatelistFromCompanyMutationVariables,
} from "./queries.types";

export const useRatelist = () => {
  const [deleteRatelist, { loading: deleting }] = useMutationHandler<
    DeleteRatelistMutation,
    DeleteRatelistMutationVariables
  >(DeleteRatelist);

  const [setStatus, { loading: settingStatus }] = useMutationHandler<
    SetRatelistStatusMutation,
    SetRatelistStatusMutationVariables
  >(SetRatelistStatus);

  const [copyRatelist, { loading: copying }] = useMutationHandler<CopyRatelistMutation, CopyRatelistMutationVariables>(
    CopyRatelist
  );

  const [create, { loading: creating }] = useMutationHandler<CreateRateMutation, CreateRateMutationVariables>(
    CreateRate
  );

  const [update, { loading: updating }] = useMutationHandler<EditRateMutation, EditRateMutationVariables>(EditRate);

  const [setDefault, { loading: settingDefault }] = useMutationHandler<
    SetDefaultRatelistMutation,
    SetDefaultRatelistMutationVariables
  >(SetDefaultRatelist);

  const [setDefaultForCompany, { loading: settingDefaultForCompany }] = useMutationHandler<
    SetDefaultRatelistForCompanyMutation,
    SetDefaultRatelistForCompanyMutationVariables
  >(SetDefaultRatelistForCompany);

  const [removeDefaultForCompany, { loading: removingDefaultForCompany }] = useMutationHandler<
    RemoveDefaultRatelistForCompanyMutation,
    RemoveDefaultRatelistForCompanyMutationVariables
  >(RemoveDefaultRatelistForCompany);

  const [unlinkFromCompany, { loading: unlinking }] = useMutationHandler<
    UnlinkRatelistFromCompanyMutation,
    UnlinkRatelistFromCompanyMutationVariables
  >(UnlinkRatelistFromCompany);

  const [linkToCompany, { loading: linking }] = useMutationHandler<
    LinkRatelistToCompanyMutation,
    LinkRatelistToCompanyMutationVariables
  >(LinkRatelistToCompany);

  return {
    update,
    remove: deleteRatelist,
    copy: copyRatelist,
    create,
    setStatus,
    setDefault,
    setDefaultForCompany,
    removeDefaultForCompany,
    unlinkFromCompany,
    linkToCompany,
    loading:
      deleting ||
      copying ||
      creating ||
      updating ||
      settingStatus ||
      settingDefault ||
      settingDefaultForCompany ||
      removingDefaultForCompany ||
      unlinking ||
      linking,
  };
};
